import { EMPTY_USER_MODEL } from "presentation/model/User/UserModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: UserProvider,
    useTracked: useUserTracked
} = createContainer(() => useState(EMPTY_USER_MODEL), {concurrentMode: true});
export {UserProvider, useUserTracked};